import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DateIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Date",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M9.24 15.51h1.93c.53 0 .96.43.96.96v1.93c0 .53-.43.96-.96.96H9.24a.96.96 0 0 1-.96-.96v-1.93c0-.53.43-.96.96-.96m5.78 0h1.93c.53 0 .96.43.96.96v1.93c0 .53-.43.96-.96.96h-1.93a.96.96 0 0 1-.96-.96v-1.93c0-.53.43-.96.96-.96m5.79 0h1.93c.53 0 .96.43.96.96v1.93c0 .53-.43.96-.96.96h-1.93a.96.96 0 0 1-.96-.96v-1.93c0-.53.43-.96.96-.96M9.23 21.3h1.93c.53 0 .96.43.96.96v1.93c0 .53-.43.96-.96.96H9.23a.96.96 0 0 1-.96-.96v-1.93c0-.53.43-.96.96-.96m5.78 0h1.93c.53 0 .96.43.96.96v1.93c0 .53-.43.96-.96.96h-1.93a.96.96 0 0 1-.96-.96v-1.93c0-.53.43-.96.96-.96M10.69 2h-.05c-.8 0-1.45.65-1.45 1.45v2.41H6.83c-1.85 0-3.36 1.49-3.38 3.33v17.42c0 1.87 1.51 3.38 3.38 3.38h13.55c.38 0 .73-.15.99-.39s6.81-6.8 6.81-6.8c.23-.26.38-.6.38-.97V9.19c0-1.87-1.51-3.38-3.38-3.38h-2.36V3.45c0-.8-.65-1.45-1.45-1.45h-.05c-.79.02-1.42.66-1.42 1.45v2.41h-7.78V3.45c0-.79-.63-1.43-1.42-1.45ZM6.8 27.1a.49.49 0 0 1-.49-.49V13.58h19.34v7.6l-.12.12h-3.7c-1.07 0-1.94.87-1.94 1.94v3.73l-.12.12H6.8Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M25.86 29.29H5.29c-1.89 0-3.43-1.54-3.43-3.43v-9.14a1.14 1.14 0 1 1 2.28 0v9.14c0 .63.51 1.14 1.14 1.14h20.57c.63 0 1.14-.51 1.14-1.14V7.57c0-.63-.51-1.14-1.14-1.14H5.29c-.63 0-1.14.51-1.14 1.14v4.57a1.14 1.14 0 1 1-2.28 0V7.57c0-1.89 1.54-3.43 3.43-3.43h20.57c1.89 0 3.43 1.54 3.43 3.43v18.29c0 1.89-1.54 3.43-3.43 3.43Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M9.86 8.71c-.63 0-1.14-.51-1.14-1.14V3A1.14 1.14 0 1 1 11 3v4.57c0 .63-.51 1.14-1.14 1.14M15.57 8.71c-.63 0-1.14-.51-1.14-1.14V3a1.14 1.14 0 1 1 2.28 0v4.57c0 .63-.51 1.14-1.14 1.14M21.29 8.71c-.63 0-1.14-.51-1.14-1.14V3a1.14 1.14 0 1 1 2.28 0v4.57c0 .63-.51 1.14-1.14 1.14M23.57 13.29H3a1.14 1.14 0 1 1 0-2.28h20.57a1.14 1.14 0 1 1 0 2.28"
      })]
    })
  }));
};
DateIcon.displayName = 'DateIcon';